import React from 'react';

function Philosophy() {
  return (
    <section id="philosophy" className="philosophy">
      <div className="container">
        <h2>The Philosophy Behind Rida Therapy</h2>
        <p>
          The name of my practice, <strong>Rida (رضا)</strong>, is an Arabic word meaning a deep and peaceful sense of <strong>contentment and acceptance</strong>.
          <br /><br />
          This is the heart of my therapeutic approach. It’s the journey of moving from a place of internal struggle to a state of inner calm. It’s about learning to accept yourself, navigate life’s challenges with grace, and find satisfaction not in a perfect life, but in the strength you discover within your own. My goal is to help you find <em>your</em> Rida.
        </p>
      </div>
    </section>
  );
}

export default Philosophy;
